/**
 * @owner @Appboy/messaging-experience
 */
import { sparseSegmentRemoteLookupValidators } from "../.generated/sparseSegmentRemoteLookup";
import type { SparseSegmentRemoteLookupProvider } from "../.generated/sparseSegmentRemoteLookup";

export const sparseSegmentProvider: SparseSegmentRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: sparseSegmentRemoteLookupValidators,
};
